import { createSelector } from "reselect"
import { get, keyBy } from "lodash"
import { getModels as getRawModels } from "resources/models"

export const getLastestUploadedDate = state => get(state, "global.data.portfolio.data.latestUploadedDate")
export const getEarliestUploadedDate = state => get(state, "global.data.portfolio.data.availableFrom")

export const getModels = createSelector(
  [getRawModels],
  (models) => keyBy(models, "id"),
)

export const getPortfolioDates = createSelector(
  [getLastestUploadedDate, getEarliestUploadedDate],
  (latest, earliest) => ({
    earliest,
    latest,
  }),
)
